/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { createMyFarmlandsApi, type MyFarmlandsApi } from "@farmlands/myfarmlands-api";
import type { AxiosError } from "axios";

import { error as logError } from "../../util/log";

let getAccessToken: () => Promise<string> = async () => "";

export const setMyFarmlandsApiGetAccessToken = (fn: () => Promise<string>): void => {
  getAccessToken = fn;
};

let myFarmlandsApiInstance: MyFarmlandsApi | null = null;

const buildInstance = (): MyFarmlandsApi =>
  createMyFarmlandsApi({
    baseURL: process.env.REACT_APP_MYFARMLANDS_API_URL ?? "",
    enableAuth: true,
    getAccessToken: () => getAccessToken(),
    onError: (axiosError: AxiosError) => {
      logError(
        `myFarmlandsApi ${axiosError.config?.method?.toUpperCase()} ${axiosError.config?.url} failed`,
        axiosError.message
      );
    },
  });

export const myFarmlandsApi: MyFarmlandsApi = new Proxy({} as MyFarmlandsApi, {
  get(_, prop) {
    if (!myFarmlandsApiInstance) {
      myFarmlandsApiInstance = buildInstance();
    }

    return myFarmlandsApiInstance[prop as keyof MyFarmlandsApi];
  },
});
